import { useState } from 'react';
import { ActionSheet, ActionSheetItem } from '@vkontakte/vkui';
import GuestAvatar from './GuestAvatar';
import type { Guest, SeatingTable } from '../../types';

interface UnseatedListProps {
  guests: Guest[];
  tables: SeatingTable[];
  guestsByTable: Map<string, Guest[]>;
  groupNameById: Map<string, string>;
  onPick: (guest: Guest, table: SeatingTable) => void;
}

export default function UnseatedList({ guests, tables, guestsByTable, groupNameById, onPick }: UnseatedListProps) {
  const [pickerGuest, setPickerGuest] = useState<Guest | null>(null);
  const [pickerAnchor, setPickerAnchor] = useState<Element | null>(null);

  return (
    <>
      <div className="st-sec">
        <h2 className="st-sec__h2">
          Без стола<span className="st-sec__count">{guests.length}</span>
        </h2>
      </div>
      {guests.length === 0 ? (
        <div className="st-muted" style={{ padding: '4px 2px', fontSize: 13 }}>Все гости рассажены</div>
      ) : (
        <div className="st-ul">
          {guests.map((g) => {
            const group = g.group_id ? groupNameById.get(g.group_id) : null;
            return (
              <div className="st-li" key={g.id} id={`st-unseated-${g.id}`}>
                <GuestAvatar id={g.id} first_name={g.first_name} last_name={g.last_name} size={38} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className="st-li__n">
                    {g.first_name} {g.last_name}
                  </div>
                  {group && <div className="st-li__s">{group}</div>}
                </div>
                <button
                  type="button"
                  className="st-pick"
                  ref={(el) => {
                    if (pickerGuest?.id === g.id) setPickerAnchor(el);
                  }}
                  onClick={(e) => {
                    setPickerAnchor(e.currentTarget);
                    setPickerGuest(g);
                  }}
                >
                  Выбрать стол ▾
                </button>
              </div>
            );
          })}
        </div>
      )}

      {pickerGuest && (
        <ActionSheet
          mode="sheet"
          title={`Стол для ${pickerGuest.first_name}`}
          toggleRef={pickerAnchor}
          onClosed={() => setPickerGuest(null)}
          iosCloseItem={<ActionSheetItem mode="cancel">Отмена</ActionSheetItem>}
        >
          {tables.map((t) => {
            const filled = (guestsByTable.get(t.id) || []).length;
            return (
              <ActionSheetItem key={t.id} onClick={() => onPick(pickerGuest, t)}>
                {t.name} · {filled}/{t.seats}
              </ActionSheetItem>
            );
          })}
        </ActionSheet>
      )}
    </>
  );
}
